import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlusOneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"plus_one"}/>
}
